import { Avatar } from 'antd';
import { node, string } from 'prop-types';
import React from 'react';

const IconWrapper = ({ children, backgroundColor }) => (
  <Avatar
    className="top-menu-field-groups__toggle-icon-wrapper"
    style={{ backgroundColor }}
    shape="square"
    size={40}
    icon={children}
  />
);

IconWrapper.propTypes = {
  children: node.isRequired,
  backgroundColor: string.isRequired,
};

export default IconWrapper;
